import axios from 'axios'
import { DateTime } from 'luxon'
import { enqueueSnackbar } from 'notistack'
import { RefObject } from 'react'
import Webcam from 'react-webcam'

export const clipboardHandler = async (link: string) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(link)
    } else {
      const textarea = document.createElement('textarea')
      textarea.value = link
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      const copied = document.execCommand('copy')
      document.body.removeChild(textarea)
      if (!copied) throw new Error('execCommand copy failed')
    }
    enqueueSnackbar('Link copied to clipboard', { variant: 'success' })
  } catch (error) {
    console.error('Error copying Link to clipboard:', error)
    enqueueSnackbar('Copy to clipboard failed', { variant: 'error' })
  }
}
export const getErrorMessage = (error: any): string => {
  console.error(error)

  let message = error?.message || error?.error || 'Something went wrong. Please try again.'

  const errors = error?.data?.errors
  if (Array.isArray(errors)) {
    message = errors.map((err) => `${err.field} : ${err.message}`).join(', \n')
  } else if (error?.data?.message) message = error.data.message
  else if (error?.data?.error) message = error.data.error
  enqueueSnackbar(message, { variant: 'error' })
  return message
}

export const fDate = (date?: string) => {
  return date ? new Date(date).toLocaleString() : '-'
}

export const fDuration = (start: string, end: string) => {
  if (!end) return '-'
  return DateTime.fromISO(end).diff(DateTime.fromISO(start)).toFormat('hh:mm:ss')
}

// export const pyAxios = axios.create({ baseURL: import.meta.env.VITE_PY_URL })
export const visionAxios = axios.create({
  baseURL: import.meta.env.VITE_VISION_URL,
  headers: { Authorization: `Bearer ${import.meta.env.VITE_VISION_TOKEN}` },
})

export const handleStopRecording = (
  mediaRecorderRef: RefObject<MediaRecorder>
) => {
  if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
    mediaRecorderRef.current.stop()
    console.log('Manually stopped recording')
  }
}

export const handleStartRecording = (
  webcamRef: RefObject<Webcam>,
  mediaRecorderRef: RefObject<MediaRecorder>,
  setRecording: (_: boolean) => void,
  id: number,
  recType: string,
  timeOut: any,
  autoStop: boolean = true
) =>
  new Promise(async (resolve, reject) => {
    if (!webcamRef.current?.stream) return console.log('failed')
    console.log('call')

    let image = await getBlob(webcamRef.current)
    console.log(image)

    let forceStopped = false

    //@ts-expect-error
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: 'video/mp4',
      // videoBitsPerSecond: 500000, // 2.4mb for 2 mins when 10 frames per second
      videoBitsPerSecond: 1000000, // 4.2mb for 2 mins when 10 frames per second
    })

    let chunks: Blob[] = []
    mediaRecorderRef.current.ondataavailable = (event) => {
      if (event.data.size > 0) chunks.push(event.data)
    }

    mediaRecorderRef.current.onstop = async () => {
      if (chunks.length) {
        const config = { headers: { 'Content-Type': 'multipart/form-data', id } }
        const blob = new Blob(chunks, { type: 'video/webm' })

        if (forceStopped) {
          setRecording(false)
          resolve(0)
          return
        }

        if (recType === 'customer') {
          try {
            const formData = new FormData()
            formData.append('video', blob, 'kyc_recording.mp4')
            await fetch(`/api/v1/kyc/${id}/recording`, { method: 'POST', body: formData })
          } catch (error) {
            console.log('recording upload failed', error)
          }
          setRecording(false)
          resolve(1)
        }

        // if (recType === 'document') {
        //   const file = new File([blob], 'doc_video_5sec')
        //   try {
        //     const formData = new FormData()
        //     formData.append('doc_video', file, 'doc_video_5sec')

        //     const payload = { image: image.split(',')[1], id: `${id}` }
        //     await pyAxios.post(`/doc_image`, payload)
        //     await pyAxios.post('/doc_video ', formData, config)

        //     setRecording(false)

        //     resolve(1)
        //   } catch (error) {
        //     console.log(error)
        //     reject(error)
        //   }
        // }

        chunks = []
      }
    }

    setRecording(true)
    mediaRecorderRef.current.start()
    console.log('recording started')

    if (autoStop) {
      const timer = setTimeout(async () => {
        mediaRecorderRef.current?.stop()
        console.log('recording stopped')

        clearTimeout(timer)
      }, 10 * 1000)
    } else {
      mediaRecorderRef.current.onstart = async () => {
        const stopTimer = setTimeout(() => {
          if (mediaRecorderRef.current?.state === 'recording') {
            console.log('KYC timed out')
            forceStopped = true
            mediaRecorderRef.current.stop()
            timeOut()
          }
          clearTimeout(stopTimer)
        }, 2 * 60 * 1000) // 2 minutes
      }
    }
  })

export const getBlob = (ref: any): Promise<Blob> =>
  new Promise((resolve, _reject) => {
    ref.getCanvas()?.toBlob((blob: Blob) => {
      resolve(blob)
    })
  })

// convert base64 to blob
// const [, imageSrcB64] = image.split(',', 2)
// const bstr = atob(imageSrcB64)
// const u8arr = new Uint8Array(bstr.length)
// for (let i = 0; i < bstr.length; i++) {
//   u8arr[i] = bstr.charCodeAt(i)
// }
// const imageBlob = new Blob([u8arr], { type: 'image/jpeg' })
